const Index = () => {
  return (
    <div className="unique-mini-layout-outer-container">
      <div className="unique-mini-layout-inner-container">UNIQUE | MINI</div>
    </div>
  )
}

export default Index
